import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FormikContextType, useFormikContext } from 'formik'
import { Column, Columns } from '@machobear/design-system'
import { isNullOrEmpty } from '@/utils'
import { getLinkServiceDisplayName } from './util'
import UploadVideoPreview from './upload-video-preview'
import VideoLinkModalBtn from './video-link-modal-btn'
import LinkedVideoPreview from './linked-video-preview'
import VideoUploadBtn from './video-upload-btn'
import { FormBox, FormBoxSkeleton, Counter } from '../components'
import { MediaFormValues } from '../types'

const VideoSection = ({ isLoading }: { isLoading: boolean }) => {
  const { t } = useTranslation()
  const { values }: FormikContextType<MediaFormValues> = useFormikContext<MediaFormValues>()
  const [uploadingVideo, setUploadingVideo] = useState(false)

  const {
    listing_id: listingId,
    unit_id: unitId,
    videos: listingVideos = [],
    listingLinks
  } = values
  const videoLink = listingLinks?.tour_video || {}
  const hasVideoFile = !isNullOrEmpty(listingVideos)
  const hasVideoLink = !isNullOrEmpty(videoLink)
  const hasVideo = hasVideoFile || hasVideoLink
  const displayName = getLinkServiceDisplayName(videoLink.link_service)

  return (
    <FormBox
      label={t('Video', 'Video')}
      icon={
        <Counter
          name={t('Video', 'Video')}
          count={hasVideo ? 1 : 0}
          max={1}
          isLoading={isLoading}
        />
      }
    >
      {isLoading ? (
        <FormBoxSkeleton />
      ) : (
        <>
          {hasVideoFile && (
            <UploadVideoPreview
              label="Video"
              listingId={listingId}
              unitId={unitId}
              videoData={listingVideos}
              isUploading={uploadingVideo}
              setIsUploading={setUploadingVideo}
            />
          )}
          {hasVideoLink && (
            <LinkedVideoPreview
              label={`${displayName} Video`}
              listingId={listingId}
              videoData={videoLink}
              videoType="2d"
            />
          )}
          {!hasVideo && (
            <Columns space="gutter" collapseBelow="tablet">
              <Column>
                <VideoUploadBtn
                  unitId={unitId}
                  isUploading={uploadingVideo}
                  setIsUploading={setUploadingVideo}
                />
              </Column>
              <Column>
                <VideoLinkModalBtn listingId={listingId} videoType="2d" disabled={uploadingVideo} />
              </Column>
            </Columns>
          )}
        </>
      )}
    </FormBox>
  )
}

export default VideoSection
